<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1" @click="backNub(-2)">当前位置：培训管理</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1" @click="backNub(-2)">网授课程表</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1" @click="backNub(-1)">课程详情</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">课题列表</div>
			</div>
			<div class="r f-ct" @click="backNub(-2)">
				<div class="t2">返回课程列表</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<div class="pageCon">
			<!-- 表格 -->
			<div class="biaoge animate__animated animate__fadeIn" data-wow-duration="0.8s">
				<div class="table">
					<div class="th f-ct">
						<p class="t1">序号</p>
						<p class="t2">课题名称</p>
						<p class="t3">讲师名称</p>
						<p class="t3">学习资料</p>
						<p class="t3">刷题</p>
						
						<p class="t3" v-if="configbaseMsg.simulateExamOpen*1">模拟考试</p>
						<p class="t3" v-if="configbaseMsg.simulateExamOpen*1">视频学习</p>
						<p class="t5" v-else>视频学习</p>
					</div>
					<div class="td f-ct" v-for="(item,index) in classNmaeList">
						<p class="t1">{{item.id}}</p>
						<p class="t2">{{item.name}}</p>
						<p class="t3">{{item.lecturerName}}</p>
						<div class="t4 f-ct" @click="opendown(item)">
							<el-image :src="require('@/static/icon74.png')"></el-image>
							<span>下载</span>
						</div>
						<p class="t4" @click="shuati(item)">进入</p>
						<p class="t4" @click="gomoni(item)" v-if="configbaseMsg.simulateExamOpen*1">进入</p>
						
						<p class="t4" v-if="configbaseMsg.simulateExamOpen*1" @click="link('/classVideo',{id:item.id,cid:id})">进入</p>
						<p class="t5" v-else @click="link('/classVideo',{id:item.id,cid:id})">进入</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbDown=false" v-if="hbDown"></div>
		<div class="subTips" v-if="hbDown">
			<div class="hbTit f-bct">
				<p>下载资料</p>
				<el-image @click="hbDown=false" class="cha" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="Tab">
				<div class="th f-ct">
					<p class="t3">资料名称</p>
					<p class="t4">文件大小</p>
					<p class="t5">下载</p>
				</div>
				<div class="tdBox">
					<div class="td f-ct" v-for="(item,index) in hbDownItem">
						<div class="t3">{{item.fileName}}</div>
						<div class="t4">{{item.fileSize}}KB</div>
						<div class="t5 f-ct" @click="wlLink(item.fileUrl)">
							<el-image :src="require('@/static/icon74.png')"></el-image>
							<span>下载</span>
						</div>
					</div>
				</div>
			</div>
			<div class="hbbtnBox f-ct">
				<div class="b1" @click="hbDown=false">返回</div>
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { courseVideolistByOrderId,configbase,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbDown:false,
			hbDownItem:'',
			id:0,
			// 列表
			classNmaeList:[],
			configbaseMsg:'',
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		// 获取信息
		this.courseVideolistByOrderId()
		this.configbase()
	},
	methods:{
		// 基本配置
		async configbase(){
			let res = await configbase({});
			if(res.code==200){
				this.configbaseMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转刷题
		shuati(item){
			localStorage.setItem("shuatiName", item.name);
			this.link('/classShuati',{id:item.id,cid:this.id})
		},
		// 跳转模拟考
		gomoni(item){
			localStorage.setItem("moniName", item.name);
			this.link('/classProblem',{id:item.id,cid:this.id})
		},
		// 打开下载列表
		opendown(item){
			if(item.fileList.fileList){
				this.Tips('暂无相关下载','error')
				return
			}
			this.hbDown = true
			this.hbDownItem = item.fileList
		},
		// 1.获取课程的视频列表-根据订单ID 课程
		async courseVideolistByOrderId(){
			let res = await courseVideolistByOrderId({courseOrderId:this.id});
			if(res.code==200){
				this.classNmaeList = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>

.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.pageCon{
	margin: 0 40px;
	padding: 24px;
	background: #fff;
	border-radius: 20px;
}
.biaoge{
	// padding: 24px;
	// padding-top: 0;
	// background: #fff;
	// margin: 0 40px;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 739px;
				padding-left: 14px;
				text-align: left;
			}
			.t3{
				width: 140px;
			}
			.t5{
				width: 280px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				&:last-child{
					border-right: 0;
				}
			}
			>div{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				justify-content: center;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 739px;
				text-align: left;
			}
			.t3{
				width: 140px;
			}
			.t5{
				width: 280px;
				color: #3B6492;
				cursor: pointer;
				.el-image{
					width: 18px;
					height: 18px;
				}
			}
			.t4{
				width: 140px;
				color: #3B6492;
				cursor: pointer;
				.el-image{
					width: 18px;
					height: 18px;
				}
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	// width: 742px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.Tab{
		margin: 0 15px;
		margin-top: 20px;
		margin-bottom: 22px;
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 51px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 51px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBF0FC;
				font-weight: bold;
				&:last-child{
					border: none;
				}
			}
			.t3{
				width: 507px;
				text-align: left;
				padding-left: 24px;
			}
			.t4{
				width: 113px;
			}
			.t5{
				width: 100px;
			}
		}
		.tdBox{
			max-height: 250px;
			overflow-y: scroll;
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				word-wrap:break-word;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 16px 8px;
				&:last-child{
					border: none;
				}
			}
			.t3{
				width: 507px;
				text-align: left;
				justify-content: flex-start;
				padding-left: 24px;
			}
			.t4{
				width: 113px;
			}
			.t5{
				width: 100px;
				cursor: pointer;
				.el-image{
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
				span{
					font-size: 14px;
					color: #3B6492;
				}
			}
		}
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>